interface Person {
  firstname?: string | null
  name?: string | null
}

export const fullNameOf = ({ firstname, name }: Person): string => [firstname, name].filter(Boolean).join(' ')

export const formatAddedAt = (addedAt: string | null): string => {
  if (!addedAt) return ''
  const date = new Date(addedAt)

  return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString('fr-FR')
}
